import { EUnitOfMeasure } from '../shared/enum';
import { TInputDrainageTrench } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureLabel, EUnitOfMeasureMetricLabel } from './enum';

export const productType: TInputDrainageTrench = 'productType';
export const drainPositionDepth: TInputDrainageTrench = 'drainPositionDepth';
export const expectedWaterTableDepth: TInputDrainageTrench = 'expectedWaterTableDepth';
export const drainLineLength: TInputDrainageTrench = 'drainLineLength';
export const drainSingle: TInputDrainageTrench = 'drainSingle';
export const wheelbase: TInputDrainageTrench = 'wheelbase';
export const hasWaterproofMembraneBelowDrain: TInputDrainageTrench = 'hasWaterproofMembraneBelowDrain';
export const heightOfSaturatedWaterTableBelowDrains: TInputDrainageTrench = 'heightOfSaturatedWaterTableBelowDrains';
export const drainPosition: TInputDrainageTrench = 'drainPosition';
export const drainHeight: TInputDrainageTrench = 'drainHeight';
export const drainUnitWidth: TInputDrainageTrench = 'drainUnitWidth';
export const drainUnitLength: TInputDrainageTrench = 'drainUnitLength';
export const numberOfDrains: TInputDrainageTrench = 'numberOfDrains';
export const numberOfDrainLines: TInputDrainageTrench = 'numberOfDrainLines';
export const waterTableLoweringThickness: TInputDrainageTrench = 'waterTableLoweringThickness';
export const hasDrainagePiping: TInputDrainageTrench = 'hasDrainagePiping';
export const fillingPercentage: TInputDrainageTrench = 'fillingPercentage';
export const roughnessCoefficient: TInputDrainageTrench = 'roughnessCoefficient';
export const hasDrainageChimney: TInputDrainageTrench = 'hasDrainageChimney';

export const drainageTrenchPD = {
    [productType]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [drainPositionDepth]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [expectedWaterTableDepth]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [drainLineLength]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [drainSingle]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [wheelbase]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [hasWaterproofMembraneBelowDrain]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [heightOfSaturatedWaterTableBelowDrains]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [drainPosition]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [drainHeight]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [drainUnitWidth]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [drainUnitLength]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [numberOfDrains]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [numberOfDrainLines]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [waterTableLoweringThickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [hasDrainagePiping]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [fillingPercentage]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.percentage,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.percentage,
        },
    },
    [roughnessCoefficient]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [hasDrainageChimney]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};
